module.exports = __webpack_public_path__ + "media/images/logo-altfee-text-18bbdcefd76d0dc146b7b9c9dae02e81.svg";